<template>
  <ul class="level2">
    <li class="subhead" @click="select(item, index)" v-for="(item, index) in items" :key="index">
      <label-status :progress="item"/> 
      <!-- {{item.name}} -->
    </li>
  </ul>
</template>

<script>
import LabelStatus from '@/components/StatusLabel'

export default {
  name: 'adx-menu-expansion-level2Status',
  components: {
    LabelStatus,
  },
  props: {
    items: {
      required: false
    },
    lists: {
      required: false
    }
  },
  methods: {
    select(item, index) {
      this.$parent.select(item, index)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>